import styled from "styled-components";

export const DealerPanelContainer = styled.div``;
